import * as React from 'react';
import ICompanySubmenu, { TCompanySubmenu } from './ICompanySubmenu';
import { NavLink } from 'react-router-dom';
import { isFeedVisible } from '@company/pages/FeedPage/functions';
import InvestBtnComponent from '@company/components/InvestBtnComponent/InvestBtnComponent';
import { classNames as cn } from '@features/utils/reactFunctions';
import noPhotoCompany from '@images/no_photo_company.png';

import * as style from './CompanySubmenuStyle.module.scss'

export default class CompanySubmenu extends React.Component<ICompanySubmenu, TCompanySubmenu> {
  state: TCompanySubmenu = {
    editMode: false,
    open: false,
  };

  componentDidMount() {
    this.setState({
      editMode: this.props.editMode,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps:ICompanySubmenu) {
    if (nextProps.editMode !== this.props.editMode) {
      this.setState({ editMode: nextProps.editMode });
    }
  }

  collapseDropdown = () => {
    if (this.state.open) {
      this.setState({ open: false });
    }
  }

  render() {
    const { editFn, cancelFn, companyDetails, children, isOwner, isCreator, userSignedIn, isUsInvestor } = this.props;
    const { editMode } = this.state;
    const avatar = companyDetails.avatar.url ? `${companyDetails.avatar.url}` : noPhotoCompany;
    return (
      <div className={cn(style.companySubmenuHolder, style.newSubmenu)}>
        <div className={style.companySubmenu}>
          <ul className={[style.companyMenu,this.state.open ? style.companyMenuOpen : null].join(' ')}>
            {
              !editMode  &&
              <React.Fragment>
                <li className={style.menuItem} data-cy="company-info">
                  <NavLink
                    activeClassName={style.active}
                    className={style.link}
                    exact={true}
                    to={`/companies/${companyDetails.slug}`}
                    onClick={this.collapseDropdown}
                  >
                    Company Info
                    <i className={style.icon}>
                      <svg className="svg-icon svg-icon--violet svg-icon--stroke4 svg-icon--size50">
                        <use xlinkHref={'#icon-company_overview'} />
                      </svg>
                    </i>
                  </NavLink>
                </li>
                {isFeedVisible(this.props.companyDetails.labels) &&
                  <React.Fragment>
                    <li className={style.menuItem} data-cy="discussion">
                      <NavLink
                        activeClassName={style.active}
                        className={style.link}
                        to={`/companies/${companyDetails.slug}/discussion`}
                        onClick={this.collapseDropdown}
                      >
                        Discussion
                      <i className={style.icon}>
                          <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                            <use xlinkHref={'#icon-activity'} />
                          </svg>
                        </i>
                      </NavLink>
                    </li>
                    {isCreator && !isOwner ? null :
                      <li className={style.menuItem} data-cy="investor-zone">
                        <NavLink
                          activeClassName={style.active}
                          className={style.link}
                          to={`/companies/${companyDetails.slug}/investor_zone`}
                          onClick={this.collapseDropdown}
                        >
                          Investor Zone
                        <i className={style.icon}>
                            <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                              <use xlinkHref={'#icon-portfolio'} />
                            </svg>
                          </i>
                        </NavLink>
                      </li>
                    }
                  </React.Fragment>
                }
                {companyDetails.trading_spv_id && companyDetails.trading_asset_id && userSignedIn &&
                  <li className={style.menuItem} data-cy="market">
                    <NavLink
                      activeClassName={style.active}
                      className={style.link}
                      to={`/companies/${companyDetails.slug}/market/spvs/${companyDetails.trading_spv_id}/orders`}
                      onClick={this.collapseDropdown}
                    >
                      Market
                      <i className={style.icon}>
                         <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                          <use xlinkHref={'#icon-activity'} />
                        </svg>
                      </i>
                    </NavLink>
                  </li>
                }
              </React.Fragment>
            }
            {
              editMode &&
              <React.Fragment>
                <li className={style.menuItem} data-cy="overview">
                  <NavLink
                    activeClassName={style.active}
                    className={style.link}
                    to={`/companies/${companyDetails.slug}/overview`}
                    onClick={this.collapseDropdown}
                  >
                    Overview
                    <i className={style.icon}>
                      <svg className={[style.svgIcon, `svg-icon svg-icon--violet svg-icon--size50`].join(' ')}>
                        <use xlinkHref={'#icon-overview'} />
                      </svg>
                    </i>
                  </NavLink>
                </li>
                { isOwner &&
                  <React.Fragment>
                    <li className={style.menuItem} data-cy="funds">
                      <NavLink
                        activeClassName={style.active}
                        className={style.link}
                        to={`/companies/${companyDetails.slug}/funds`}
                        onClick={this.collapseDropdown}
                      >
                        Funds
                        <i className={style.icon}>
                          <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                            <use xlinkHref={'#icon-kasa'} />
                          </svg>
                        </i>
                      </NavLink>
                    </li>
                    <li className={style.menuItem} data-cy="verification">
                    <NavLink
                        activeClassName={style.active}
                        className={style.link}
                        to={`/companies/${companyDetails.slug}/verification`}
                        onClick={this.collapseDropdown}
                    >
                      Verification
                      <i className={style.icon}>
                          <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                            <use xlinkHref={'#icon-pitches'} />
                          </svg>
                        </i>
                    </NavLink>
                  </li>
                    <li className={style.menuItem} data-cy="collaborators">
                    <NavLink
                      activeClassName={style.active}
                      className={style.link}
                      to={`/companies/${companyDetails.slug}/collaborators`}
                      onClick={this.collapseDropdown}
                    >
                      Collaborators
                      <i className={style.icon}>
                        <svg className="svg-icon svg-icon--violet svg-icon--stroke8 svg-icon--size50">
                          <use xlinkHref={'#icon-followers'} />
                        </svg>
                      </i>
                    </NavLink>
                  </li>
                  </React.Fragment>
                }
              </React.Fragment>
            }
          </ul>
          {
            <div className={style.buttonsHolder}>
              <InvestBtnComponent editMode={editMode} isUsInvestor={isUsInvestor} userSignedIn={userSignedIn} />
              {(isOwner || isCreator) &&
                <React.Fragment>
                  {editMode &&
                    <button
                      className={[style.button, style.buttonPublic].join(' ')}
                      onClick={cancelFn}
                      data-cy="public-view"
                    >
                      Public View
                    </button>
                  }
                  {!editMode &&
                    <button className={style.button} onClick={editFn} data-cy="manage-page">
                      Manage Page
                </button>
                  }
                </React.Fragment>}
            </div>
          }
          <div
            id="j-toggle-btn"
            className={[style.linksToogle, this.state.open ? style.linksToogleOpen : null].join(' ')}
            onClick={() => {this.setState({ open:!this.state.open });}}
          />
        </div>
        <div>
          {children}
        </div>
      </div>
    );
  }
}
